module.exports = __webpack_public_path__ + "img/video_commentary_image.a85db94c.png";